<template>
  <div class="layout-wrapper tmp-hide">
    <Sidebar
      v-if="layoutType === 'vertical' && $route.name !== '404'  &&  !isAnonymousRoute "
      :collapsed="collapsed"
      @update:collapsed="collapsed = $event"
    />

    <div
      class="layout-content"
      :class="{ collapsed }"
      :style="contentStyle"
    >
      <Horizontal
        v-if="layoutType === 'vertical'"
        :layout="layoutType"
        class="zoom-container"
      >
        <slot />
      </Horizontal>
    </div>
  </div>
</template>

<script>
import { layoutComputed } from "@/state/helpers";
import Horizontal from "./horizontal";
import Sidebar from "@/components/Sidebar";
import { anonymousMenuItems } from "@/components/anonymous-Menu-Items";

export default {
  components: { Sidebar, Horizontal },

  data() {
    return {
      collapsed: false,
      isMobile: false
    };
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    ...layoutComputed,

    isAnonymousRoute() {
      const currentPath = this.$route.path;
      return anonymousMenuItems.some(item => item.link === currentPath)  || this.$route.name == 'demo';
    },

    // Dynamic style for layout-content
    contentStyle() {
      if (this.$route.name === '404'  ||  this.isAnonymousRoute) {
        return { marginLeft: '0', width: '100%' };
      }

      if (this.isMobile) {
        return { marginLeft: "60px", width: 'calc(100% - 60px)' };
      }

      return this.collapsed
        ? { marginLeft: '60px', width: 'calc(100% - 60px)' }
        : { marginLeft: '260px', width: 'calc(100% - 260px)' };
    }
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768; 
      this.collapsed = this.isMobile ? true : this.collapsed;
    }
  }
};
</script>


<style>
.layout-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.layout-content {
  min-height: 100vh;
  transition: margin-left 0.3s ease, width 0.3s ease;
  background: #f4f6fb;
}

@media screen and (max-width: 1600px) {
    .tmp-hide {
        /* display: none ; */
    } 
  }

</style>
